import Load03 from '../Load03';
import styled from 'styled-components';

type AvatarElementProps = {
  $image?: string;
};

export const AvatarElement = styled.div<AvatarElementProps>`
  border: none;
  border-radius: 50%;
  background-image: ${props =>
    props.$image ? `url(${props.$image})` : 'none'};
  background-position: center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  height: 72px;
`;

export const Loader = styled(Load03)`
  vertical-align: middle;
  display: block;
  width: 72px;
  height: 72px;
  border-radius: 50%;
`;
